export default __webpack_public_path__ + "static/media/club.af3927d8.png";